function setupShopifyXr() {
  if (!window.ShopifyXR) {
    document.addEventListener('shopify_xr_initialized', function() {
      setupShopifyXr();
      launchShopifyXR();
    });
  } else {
    window.ShopifyXR.addModels(window.kef.product.models.models);
    window.ShopifyXR.setupXRElements();
    launchShopifyXR();
  }
}
function launchShopifyXR() {
  if (window.location.hash.indexOf('ar-mode') < 0 || window.kef.product.models.is_hide) return false;

  var slide_el = $(`.product-medias-main .swiper-slide[data-media_id="${window.kef.product.models.current_model_id}"]`),
      model_el = $(`model-viewer`, slide_el);
      
  if (isMobile() && model_el.length == 1) {
    if (isMobileChrome()) {
      window.ShopifyXR.launchXR({
        model3dId: window.kef.product.models.current_model_id,
        title: window.kef.product.title,
      });
    } else {
      model_el[0].addEventListener('load', function() {
        var ivt = setInterval(function() {
          if (model_el[0].loaded && model_el[0].modelIsVisible) {
            $(`[data-shopify-xr]`, slide_el).trigger('click');
            clearInterval(ivt);
          }
        }, 1000);
      }, 3000);
    }
  }
}
function isMobile() {
  return ((/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) ||
    (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform)));
}
function isMobileChrome() {
  return ((/Chrome/i.test(navigator.userAgent)) ||
    (/Chrome/i.test(navigator.platform)));
}

// product function
var product_medias_thumb_class = '.product-medias-thumbs',
    product_medias_main_class = '.product-medias-main';
var product_medias_yt_players = {};

var yt_script = document.createElement('script');
yt_script.src = "https://www.youtube.com/iframe_api";
document.getElementsByTagName('head')[0].appendChild(yt_script);

function onYouTubeIframeAPIReady() {
  $(`${product_medias_main_class} .swiper-slide[data-media_type="external_video"] iframe`).each(function() {
    var iframe = $(this),
        elementId = iframe.attr('id'),
        videoId = iframe.attr('data-video_id');

    product_medias_yt_players[elementId] = new YT.Player(elementId, {
      videoId: videoId,
    });
  });
}
var product_fn = {
  product_medias_clicked_slide: '',
  product_medias_thumbs_swiper: '',
  product_medias_slideshow_swiper: '',
  medias: {
    stopVideo: () => {
      $.each(product_medias_yt_players, function(key, player) {
        var state = player.getPlayerState();
        if (state == YT.PlayerState.PLAYING) {
          player.stopVideo();
        }
      });

      $(`${product_medias_main_class} .swiper-slide[data-media_type="video"] video`).each(function() {
        var video = $(this).get(0);
        video.pause();
        video.currentTime = 0;
      });
    },
    init: () => {
      product_fn.product_medias_thumbs_swiper = new Swiper(`${product_medias_thumb_class} .swiper`, {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 8,
        slidesPerView: 5,
        slidesPerGroup: 5,
        slideToClickedSlide: true,
        // freeMode: true,
        // watchSlidesProgress: true,
        centeredSlidesBounds: true,
        initialSlide: $(`${product_medias_thumb_class} .is-active`).index() || 0,
        pagination: {
          el: `${product_medias_thumb_class} .swiper-pagination`,
          clickable: true,
        },
        navigation: {
          nextEl: `${product_medias_thumb_class} .swiper-button-next`,
          prevEl: `${product_medias_thumb_class} .swiper-button-prev`,
        },
        scrollbar: {
          el: `${product_medias_thumb_class} .swiper-scrollbar`,
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          750: {
            direction: 'vertical',
            centeredSlidesBounds: false,
          },
        },
      });
      product_fn.product_medias_slideshow_swiper = new Swiper(`${product_medias_main_class} .swiper`, {
        direction: 'horizontal',
        loop: false,
        speed: 1,
        allowTouchMove: false,
        autoHeight: true,
        initialSlide: $(`${product_medias_main_class} .is-active`).index() || 0,
        pagination: {
          el: `${product_medias_main_class} .swiper-pagination`,
          clickable: true,
        },
        navigation: {
          nextEl: `${product_medias_main_class} .swiper-button-next`,
          prevEl: `${product_medias_main_class} .swiper-button-prev`,
        },
        scrollbar: {
          el: `${product_medias_main_class} .swiper-scrollbar`,
        },
        thumbs: {
          swiper: product_fn.product_medias_thumbs_swiper,
          multipleActiveThumbs: false,
        },
        breakpoints: {
          750: {
          },
        },
        on: {
          slideChangeTransitionEnd: function(swiper) {
            product_fn.medias.stopVideo();

            var active_slide = $(swiper.slides[swiper.activeIndex]),
                media_type = active_slide.attr('data-media_type');
            if (media_type == 'video') {
              $('video', active_slide).get(0).play();
            } else if (media_type == 'external_video') {
              var elementId = $('iframe', active_slide).attr('id'),
                  player = product_medias_yt_players[elementId];
              player.playVideo();
            }
          },
        },
      });

      $(`${product_medias_main_class} .swiper-slide[data-media_type="video"] video`).each(function() {
        var _t = $(this),
            alt_text = _t.attr('aria-label');
        $('img', _t).attr('alt', alt_text);
      });
    },
  },

  scrollToGallery: () => {
    $('html, body').stop().animate({
      scrollTop: 0
    }, 300);
  },

  setProductTitleSpacing: () => {
    var title_el = $('.product-single-title'),
        title_text = title_el.text().split(' ').map(function(t) {
          return `<span>${t}</span>`;
        }).join(' ');
    title_el.html(title_text);
  },
  setGrilleName: (_this) => {
    if (window.location.pathname.indexOf('grille') < 0) return;

    var title_el = $('.product-single-title');
    let index = window.location.pathname.indexOf('reference') >= 0 ? 2 : 0;

    let arr = _this.val().split(` `), 
        val = ``;
    arr = arr.filter(function(e){ return e.indexOf(`(`) == -1 && e.indexOf(`)`) == -1; });
    val = arr.join(` `);
    arr = (index > 0 && [].includes(Shopify.locale)) 
      ? val.split(` `, val.split(` `).length).slice(-2) 
      : val.substring(0, val.split(' ', index > 0 ? index :  1).join(' ').length).split(` `);
        
    title_el.text(kef.product.title + ' - ' + arr.join(` `));
  },

  init: function() {
    var product_container = $('.product-container'),
        product_single = $('.product-single', product_container),
        product_medias = $('.product-single-medias', product_single),
        product_info = $('.product-single-info', product_single),
        product_form = $('.product-form', product_info);

    product_fn.setGrilleName($('input[name*="swatch"]:checked', product_form));

    $('body')
      .on('click', '#image-viewer .image-viewer-close', function(e) {
        // hide image popup
        var popup = $('#image-viewer');

        if (popup.length == 1) popup.fadeOut(100, function() {
          popup.remove();
        });
        $('body').removeClass('scroll-none');
        e.preventDefault();
      })
      .on('click', '#ar-model-viewer .ar-model-details label', function() {
        // update 3d model popup
        // update variant selection
        $('div[data-sku="'+$(this).parent('div').attr('data-sku')+'"] label', product_form).trigger('click');
      })
      .on('click', '#ar-model-viewer .ar-model-viewer-close', function(e) {
        // hide 3d model popup
        var popup = $('#ar-model-viewer');

        if (popup.length == 1) popup.remove();
        $('body').removeClass('scroll-none');
        e.preventDefault();
      })
      .on('click', function(e) {
        // hide variant dropdown
        if ($(e.target).closest('.product-swatch-dropdown').length == 0 && $('.product-swatch-dropdown.active').length > 0) {
          $(this).removeClass('active');
        }
      })
      ;
  
    product_container
      .on('click', 'a[href*="#ar-gallery"]', function(e) {
        product_fn.scrollToGallery();
        e.preventDefault();
      })
      ;

    // product_medias
    product_fn.medias.init();
    product_medias
      .on('click', '.product-medias-main .swiper-slide[data-media_type="image"] .product-image-container', function(e) {
        // show image popup
        var popup = $('#image-viewer');
            clone = $(this).clone().attr('id', 'image-viewer').css({
              'background-image': `url(${$(this).attr('data-image')})`,
            });

        if (popup.length == 1) popup.remove();
        clone.appendTo('body');
        $('#image-viewer').fadeIn(100);
        $('body').addClass('scroll-none');
        e.preventDefault();
      })
      .on('click', '.product-medias-main .swiper-slide[data-media_type="model"] .ar-button', function(e) {
        // show 3d model popup
        if (isMobile()) return false;

        var popup = $('#ar-model-viewer');
            clone = $(this).parent('.product-model-container').clone().attr('id', 'ar-model-viewer');

        if (popup.length == 1) popup.remove();
        clone.appendTo('body');
        $('body').addClass('scroll-none');
        e.preventDefault();
      })
      .on('click', '.product-medias-thumbs .swiper-slide', function() {
        // update variant selection
        var slide_el = $(this),
            variant_images = slide_el.attr('data-media_filename').split(',');

        $.each(variant_images, function(idx, variant_image) {
          var option = $('#add-to-cart-form option[data-variant_images*="'+variant_image+'" i]');
          if (option.length > 0) {
            product_fn.product_medias_clicked_slide = slide_el.attr('data-media_type');
            var input_el = $('div[data-sku="'+option.attr('data-sku')+'"] input[name*="swatch"]', product_form);
            input_el.prop('checked', true).trigger('change');
          }
        });
      })
      ;

    // product single
    // product title
    if (window.kef.product.handle = 'c-link-interspeaker-cable') {
      product_fn.setProductTitleSpacing();
    }
  
    // product variant
    if ($(`.product-variants-dropdown select option`).length == 1) {
      $(`.product-form-variants`).addClass('hide');
    }
    // replace input id [string_id]
    $('input[id*="[string_id]"]', product_single).each(function() {
      var string_id = Math.random().toString(36).substring(2,7),
          input_id = $(this).attr('id').replaceAll('[string_id]', string_id);
      
      $(this).attr('id', input_id)
        .parent().find('label').attr('for', input_id);
    });

    var price_instalment = $('.payment-method-onsite-messaging');
    var variant_option = $(`.product-variants-dropdown select option:selected`, product_form) || $(`.product-variants-dropdown select option:first`, product_form);
    price_instalment.each(function() {
      var price_instalment_price = $('span[class*="-instalment-price"]', this),
          price_instalment_month = parseInt($('span[class*="-instalment-month"]', this).text()) || parseInt(price_instalment_price.attr('data-month')) || 12,
          instalment_price = parseFloat(variant_option.attr('data-price_after')) / price_instalment_month;
      price_instalment_price.html(window.Shopify.formatMoney(instalment_price, window.kef.product.currency_format));
      $(this).removeClass('hide');
    });

    var country_of_origin_el = $('.product-country-of-origin', product_single);
    if (country_of_origin_el.length > 0) {
        var country_of_origin_text = country_of_origin_el.attr('data-text'),
            country_of_origin_val = country_of_origin_el.attr('data-value');
        (country_of_origin_val != '')
          ? country_of_origin_el.text(country_of_origin_text + ' ' + country_of_origin_val)
          : country_of_origin_el.text('');
    }

    var release_date_el = $('.product-release-date', product_single);
    if (release_date_el.length > 0) {
        var release_date_text = release_date_el.attr('data-text'),
            release_date_val = release_date_el.attr('data-value');
        (release_date_val != '')
          ? release_date_el.text(release_date_text + ' ' + release_date_val)
          : release_date_el.text('');
    }

    // product form
    product_form
      .on('change', 'input[name*="swatch"]', function() {
        // update variant selection
        product_form = $(this).parents(`.product-form`);

        var opts = [];
        $('.product-form-variants input:checked', product_form).each(function() {
          opts.push($(this).val());
        });

        var variant_option = $(`.product-variants-dropdown select option[data-variant_title="${opts.join(' / ')}"]`, product_form);
        $('.product-variants-dropdown select', product_form).val(variant_option.val());

        // reset quantity
        $('.product-form-quantity input[name="quantity"]', product_form).val(1);

        // add to cart button
        var add_to_cart_btn = $('#AddToCart-product-template', product_form),
            add_to_cart_text = variant_option.attr('data-add_to_cart_text'),
            avaiable_val = JSON.parse(variant_option.attr('data-available'));
        add_to_cart_btn.text(add_to_cart_text);
        if (avaiable_val !== false) {
          add_to_cart_btn.prop('disabled', false);
        } else {
          add_to_cart_btn.prop('disabled', true);
        }

        // update product medias
        var model_el = $('.product-medias-main .swiper-slide model-viewer[src*="'+variant_option.attr('data-model')+'" i]'),
            photo_el = $('.product-medias-main .swiper-slide img[src*="'+variant_option.attr('data-variant_image').split('?')[0]+'" i]'),
            idx = -1;
        if (model_el.length == 1) {
          idx = $('.product-medias-main .swiper-slide').index(model_el.parents('.swiper-slide'));

          var model_viewer = $('#ar-model-viewer');
          if (model_viewer.length == 1) {
            var model_el_container = model_el.parents('.product-model-container');
            $('.ar-model-container model-viewer', model_viewer)
              .attr('src', $('.ar-model-container model-viewer', model_el_container).attr('src'));
            $('.ar-model-qr img', model_viewer)
              .attr('src', $('.ar-model-qr img', model_el_container).attr('src'));
          }
        } else if (photo_el.length == 1) {
          idx = $('.product-medias-main .swiper-slide').index(photo_el.parents('.swiper-slide'));
        }
        if (idx >= 0 && product_fn.product_medias_clicked_slide == '') product_fn.product_medias_slideshow_swiper.slideTo(idx);
        product_fn.product_medias_clicked_slide = '';

        // update product info
        // title
        product_fn.setGrilleName($(this));

        // featured label
        var featured_label_el = $('.product-single-featured-label', product_single),
            featured_label_val = variant_option.attr('data-featured_label');
        (featured_label_val != '')
          ? featured_label_el.text(featured_label_val).parent().removeClass('hide')
          : featured_label_el.text('').parent().addClass('hide');

        // price
        var single_price_el = $('.product-single-prices-container', product_single);
            
            single_price_selling_el = $('.product-single-price-selling', product_single),
            single_price_before_el = $('.product-single-price-before', product_single),
            single_price_unit_el = $('.product-single-price-unit', product_single);
        single_price_selling_el.text(variant_option.attr('data-price_after_display'));
        single_price_before_el.text(variant_option.attr('data-price_before_display'));
        single_price_unit_el.text(variant_option.attr('data-sold_unit'));

        // installment
        var price_instalment = $('.payment-method-onsite-messaging');
        price_instalment.each(function() {
          var price_instalment_price = $('span[class*="-instalment-price"]', this),
              price_instalment_month = parseInt($('span[class*="-instalment-month"]', this).text()) || parseInt(price_instalment_price.attr('data-month')) || 12,
              instalment_price = parseFloat(variant_option.attr('data-price_after')) / price_instalment_month;
          price_instalment_price.html(window.Shopify.formatMoney(instalment_price, window.kef.product.currency_format));
          $(this).removeClass('hide');
        });

        // hide price
        var hide_price_val = JSON.parse(variant_option.attr('data-hide_price'));
        if (hide_price_val !== false) {
          single_price_el.addClass('hide');
        } else {
          single_price_el.removeClass('hide');
        }

        // note
        var note_el = $('.product-single-note', product_single);
        note_el.html(variant_option.attr('data-note'));

        // offer-box
        var offer_boxes_el = $('.product-offer-boxes', product_single),
            offer_box = $('.product-offer-box-'+variant_option.val());
            offer_box_main_el = $('.product-offer-box-main', product_single),
            offer_box_variant_el = $('.product-offer-box-variant', product_single);
        offer_box_variant_el.removeClass('active');
        if (offer_box.length > 0) {
          offer_boxes_el.removeClass('hide');
          offer_box_main_el.removeClass('active');
          offer_box.addClass('active');
        } else if (offer_box_main_el.length > 0) {
          offer_boxes_el.removeClass('hide');
          offer_box_main_el.addClass('active');
        } else {
          offer_boxes_el.addClass('hide');
        }

        // alt button
        var alt_button_el = $('#alt-button', product_single),
            alt_button_text = variant_option.attr('data-alt_button_text'),
            alt_button_url = variant_option.attr('data-alt_button_url') || 'javascript:void(0);';
        alt_button_el.find('a').remove();
        if (alt_button_text != '') {
          alt_button_el.removeClass('hide');
          var a = document.createElement('a');
          a.href = alt_button_url;
          a.target = alt_button_url.indexOf('http') != 0 ? '_blank' : '_self';
          a.text = alt_button_text;
          a.classList.add('btn', 'btn--full', 'btn-secondary', 'btn-block');
          alt_button_el.append(a);
        } else {
          alt_button_el.addClass('hide');
        }

        // mykef exclusive
        var mykef_exclusive_el = $('#mykef-exclusive-button', product_single),
            mykef_exclusive_val = JSON.parse(variant_option.attr('data-mykef_exclusive'));
        if (mykef_exclusive_val !== false) {
          add_to_cart_btn.addClass('hide');
          mykef_exclusive_el.removeClass('hide');
        } else {
          add_to_cart_btn.removeClass('hide');
          mykef_exclusive_el.addClass('hide');
        }

        // country of origin
        var country_of_origin_el = $('.product-country-of-origin', product_single);
        if (country_of_origin_el.length > 0) {
            var country_of_origin_text = country_of_origin_el.attr('data-text'),
                country_of_origin_val = variant_option.attr('data-country_of_origin');
            (country_of_origin_val != '')
              ? country_of_origin_el.text(country_of_origin_text + ' ' + country_of_origin_val)
              : country_of_origin_el.text('');
        }

        // release date
        var release_date_el = $('.product-release-date', product_single);
        if (release_date_el.length > 0) {
            var release_date_text = release_date_el.attr('data-text'),
                release_date_val = variant_option.attr('data-release_date');
            (release_date_val != '')
              ? release_date_el.text(release_date_text + ' ' + release_date_val)
              : release_date_el.text('');
        }

        // url
        var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant_option.val();
        window.history.replaceState({ path: newurl }, '', newurl);

        // legacy event trigger
        var event_variant = variantObj[variant_option.val().toString()];
        $('.product-container').trigger({
          type: 'variantChange',
          variant: event_variant.variant
        });
        // currency selector
        $(document).trigger({
          type: 'currenncyPriceChange',
          variant: event_variant.variant
        });

      }).on('click', '.product-swatch-elements-toggle', function() {
        // show additional variants
        $(this).parents('.product-swatch-elements').toggleClass('active');

      }).on('click', '.product-swatch-dropdown', function() {
        // show variant dropdown
        $(this).toggleClass('active');

      }).on('change', '.product-swatch-dropdown input[name*="swatch"]', function() {
        // update variant dropdown
        $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
        $('.product-swatch-dropdown').removeClass('active');

      }).on('click', '#AddToCart-product-template', product_fn.addToCart)
      ;
    // $(`input[name*="swatch"]:checked`, product_form).trigger('change');

    // 3d models
    var cls = isMobile() ? 'ar-button-mb' : 'ar-button-pc';
    $('.product-medias-main .ar-button', product_medias).addClass(cls);

    // url hash
    if (window.location.hash.indexOf('ar-gallery') >= 0) {
      product_fn.scrollToGallery();
    }
  },
  addToCart: function(e) {
    var _this = $(this),
        form = _this.parents(`.product-form`),
        item = {
          id: parseInt($('.product-variants-dropdown select', form).val()),
          quantity: parseInt($('.product-form-quantity input[name="quantity"]', form).val() || 1),
          properties: {
            'note': $('.product-variants-dropdown select option:selected', form).attr('data-note') || '',
            '_refurbished': refurbished || false,
          }
        };
    item.properties['note'] = $(`<div>${item.properties['note']}</div>`).text();

    var data = {
      items: [item],
    };

    _this.addClass('disabled');
    cart_fn.add(data).done(function(cart) {
      _this.removeClass('disabled');

      $('body').trigger({
        type: 'add_to_cart',
        quantity: [item.quantity],
        cart: cart,
      });
    }).fail(function() {
      _this.removeClass('disabled');
    }).always(function() {
      _this.removeClass('disabled');
    });
    e.preventDefault();
  },
};

$(function() {
  // product container
  product_fn.init();

  $(window).on('load', function() {
    window.Shopify.loadFeatures([{
      name: 'shopify-xr',
      version: '1.0',
      onLoad: setupShopifyXr
    }]);
  });
});